
























import { defineComponent } from '@nuxtjs/composition-api'
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons'
import CImg from '~/components/shared/configurable/image/CImg.vue'

export default defineComponent({
  components: { CImg },
  props: {
    expanded: {
      type: Boolean,
      default: false
    },
    slotClass: {
      type: [String, Object],
      default: null
    },
    customIconUrl: {
      type: String,
      default: ''
    },
    paddingClass: {
      type: String,
      default: 'tw-px-3 tw-py-2'
    }
  },
  setup() {
    return {
      faMinus,
      faPlus
    }
  }
})
